// extracted by mini-css-extract-plugin
module.exports = {"bg":"style_bg__1Jipk","title":"style_title__3YxcM"};